export default {
  PALETTE_TYPE_A: 'PALETTE_TYPE_A',
  PALETTE_TYPE_B: 'PALETTE_TYPE_B',
  PALETTE_TYPE_C: 'PALETTE_TYPE_C',
};
